import {
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
} from "@ey-xd/motif-react";
import "./UpdateOrderWarningPopUp.scss";
import Button from "../../../../components/Button/Button";
import { useEffect } from "react";

type Props = {
  isVisible: boolean;
  name: string;
  popupCloseHandler: () => void;
};

export default function UpdateOrderWarningPopUp({
  isVisible,
  name,
  popupCloseHandler,
}: Props) {
  const handleClose = () => {
    popupCloseHandler();
  };
  let errorMessage = "";
  if (name === "") {
    errorMessage = `Order name cannot be empty, Please enter a valid name`;
  } else {
    errorMessage = `The name "${name}" is already taken, Please choose a differnet name`;
  }

  useEffect(() => {
    if (isVisible) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isVisible]);

  return (
    <>
      <MotifModal
        className="updateOrderWarningPopUp"
        onClose={handleClose}
        show={isVisible}
        focusTrapOptions={{
          tabbableOptions: {
            displayCheck: "none",
          },
        }}
      >
        <div className="updateOrderWarningPopUpModelWrapper">
          <MotifModalBody>
            <div className="discard_message">
              <p>{errorMessage}</p>
            </div>
          </MotifModalBody>
          <MotifModalFooter>
            <Button
              label={"Okay"}
              variant={"secondary"}
              className="cancelBtnModal"
              onClickHandler={handleClose}
            />
          </MotifModalFooter>
        </div>
      </MotifModal>
    </>
  );
}
